import { render } from "./CashBox.vue?vue&type=template&id=15e4cd3d&scoped=true"
import script from "./CashBox.vue?vue&type=script&lang=js"
export * from "./CashBox.vue?vue&type=script&lang=js"

import "./CashBox.vue?vue&type=style&index=0&id=15e4cd3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e4cd3d"]])

export default __exports__